import React, { Component } from 'react';
import PropTypes from 'prop-types';
import common from 'ui-react-common';

const config = common.config;

const InputField = common.ui.components.forms.InputField;

export const validation = {
    validateOn: ['blur'],
    validationRegex: config.global.validation.patterns.lastName,
    required: true,
    message: {
        default: 'Please enter your last name',
    },
};

class LastName extends Component {
    render() {
        const { value, disabled } = this.props;
        return (
            <InputField
                id="lastName"
                name="lastName"
                type="text"
                placeholder="Last Name"
                validation={validation}
                value={value}
                disabled={disabled}
            />
        );
    }
}

LastName.defaultProps = {
    value: undefined,
};

LastName.propTypes = {
    value: PropTypes.string,
};

export default LastName;
